import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import cn from 'classnames';
import Preloader from '@omilia/preloader';

import Sidebar from 'components/Sidebar';

import { getSidebarIsOpen } from 'store/services/settings/selectors';

import {
  getProjectIsEmpty,
  getProjectIsLoading,
} from 'store/services/project/selectors';

// eslint-disable-next-line import/named
import { CommonHeader as Header } from 'components/Header';
import NavigationShortcuts from './components/NavigationShortcuts';

import './style.scss';

export const Bounder = props => {
  const { children, isSidebarOpen, isLoading, isEmpty } = props;

  return (
    <div className="main-wrapper" styleName="root">
      <NavigationShortcuts>
        <Header />

        <ToastContainer
          hideProgressBar
          newestOnTop
          autoClose={10000}
          closeButton={false}
          draggable={false}
          position={toast.POSITION.TOP_RIGHT}
        />

        <div
          className={cn('main-section main-content', {
            'has-sidebar': isSidebarOpen,
          })}
        >
          <Sidebar />

          {isLoading || isEmpty ? (
            <Preloader />
          ) : (
            <div className="main-container main-view">{children}</div>
          )}
        </div>

        <footer styleName="footer" />
      </NavigationShortcuts>
    </div>
  );
};

const mapStateToProps = state => ({
  isSidebarOpen: getSidebarIsOpen(state),
  isLoading: getProjectIsLoading(state),
  isEmpty: getProjectIsEmpty(state),
});

Bounder.propTypes = {
  isEmpty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSidebarOpen: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default connect(mapStateToProps)(Bounder);
